import { useContent } from "@/content";
import { useNow } from "@/lib/hooks";

export const Countdown = ({ className = "" }) => {
  const c = useContent();
  const t = c.ui.countdown;
  const target = new Date(c.site.openingDate).getTime();
  const now = useNow(1000);
  const diff = Math.max(0, target - now);
  if (diff === 0) return <p className="font-serif text-2xl text-copper" data-testid="countdown-open">{t.open}</p>;
  const s = Math.floor(diff / 1000);
  const parts = [
    [Math.floor(s / 86400), t.days, "days"],
    [Math.floor((s % 86400) / 3600), t.hours, "hours"],
    [Math.floor((s % 3600) / 60), t.minutes, "minutes"],
    [s % 60, t.seconds, "seconds"],
  ];
  return (
    <div className={className} data-testid="countdown">
      <p className="mb-4 text-[0.75rem] uppercase tracking-[0.35em] text-copper">{t.label}</p>
      <div className="flex items-start gap-2 min-[400px]:gap-4 md:gap-8" role="timer" aria-live="off">
        {parts.map(([n, label, key], i) => (
          <div key={key} className="flex items-start gap-2 min-[400px]:gap-4 md:gap-8">
            <div className="min-w-[3rem] md:min-w-[4rem]">
              <div className="font-serif text-[2rem] font-light tabular-nums leading-none md:text-[3rem]" data-testid={`countdown-${key}`}>{String(n).padStart(2, "0")}</div>
              <div className="mt-2 text-[0.68rem] uppercase tracking-[0.12em] opacity-85 md:text-[0.75rem] md:tracking-[0.25em]">{label}</div>
            </div>
            {i < 3 && <span className="font-serif text-2xl font-light text-copper/60 md:text-[1.75rem]" aria-hidden="true">·</span>}
          </div>
        ))}
      </div>
    </div>
  );
};
